import React from "react";
export default function PrivacyPage() {
  return (
    <div style={{ fontFamily: "Inter, sans-serif", padding: "40px 20px", maxWidth: "900px", margin: "0 auto", color: "#333" }}>
      <h1 style={{ fontSize: "28px", fontWeight: "700", marginBottom: "10px" }}>
        Polityka Prywatności – LunGO
      </h1>
      <p style={{ color: "#666", marginBottom: "30px" }}>
        Zasady przetwarzania danych osobowych użytkowników serwisu LunGO.<br />
        <strong>Data aktualizacji:</strong> 23.10.2025
      </p>

      <h2 style={{ marginTop: "30px" }}>1. Administrator danych</h2>
      <p>
        Administratorem danych osobowych jest <strong>Burgizza Sp. z o.o.</strong>,
        z siedzibą pod adresem ul. Kalwaryjska 69/9, 30-504 Kraków,
        NIP 6793328967, REGON 541513700 (dalej: „Administrator”).
      </p>
      <p>
        LunGO jest marką/serwisem prowadzonym przez Burgizza Sp. z o.o.
        (dalej łącznie: „LunGO” lub „Serwis”).<br />
        Kontakt w sprawach ochrony danych:{" "}
        <a href="mailto:privacy@lungoapp.pl">privacy@lungoapp.pl</a>.
      </p>

      <h2 style={{ marginTop: "30px" }}>2. Zakres i cel przetwarzania danych</h2>
      <p>Dane przetwarzamy wyłącznie w zakresie niezbędnym do działania serwisu:</p>
      <ul>
        <li>utworzenie i obsługa konta użytkownika,</li>
        <li>złożenie oraz realizacja zamówienia,</li>
        <li>kontakt w sprawie zamówienia,</li>
        <li>wysyłka e-maili związanych z logowaniem lub potwierdzeniem zamówienia,</li>
        <li>zapewnienie poprawnego działania aplikacji i obsługa techniczna (diagnostyka błędów),</li>
        <li>wypełnianie obowiązków prawnych.</li>
      </ul>
      <p><strong>LunGO nie przetwarza danych płatniczych.</strong></p>
      <p>
        <strong>Zautomatyzowane przetwarzanie:</strong> w ograniczonym zakresie możemy korzystać z rozwiązań
        automatycznych, np. do weryfikacji zasięgu dostawy i proponowania lokali
        na podstawie adresu. Nie podejmujemy decyzji wywołujących skutki prawne
        wyłącznie w oparciu o zautomatyzowane przetwarzanie.
      </p>

      <h2 style={{ marginTop: "30px" }}>3. Podstawa prawna przetwarzania</h2>
      <ul>
        <li>art. 6 ust. 1 lit. b RODO – wykonanie umowy (obsługa konta i zamówień),</li>
        <li>art. 6 ust. 1 lit. c RODO – obowiązek prawny (np. rozliczenia),</li>
        <li>art. 6 ust. 1 lit. f RODO – uzasadniony interes administratora (kontakt, bezpieczeństwo).</li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>4. Zakres przetwarzanych danych</h2>
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
        <thead>
          <tr style={{ background: "#f5f5f5" }}>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Kategoria</th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Przykłady</th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Cel</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>Dane identyfikacyjne</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>imię, nazwisko</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>kontakt i realizacja zamówienia</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>Dane kontaktowe</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>adres e-mail, numer telefonu</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>potwierdzenia i kontakt w sprawie zamówienia</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>Dane adresowe</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>ulica, nr budynku, kod, miasto</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>dostarczenie zamówienia / weryfikacja zasięgu</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>Dane techniczne</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>adres IP, cookies, logi</td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>bezpieczeństwo, analityka, diagnostyka</td>
          </tr>
        </tbody>
      </table>

      <h2 style={{ marginTop: "30px" }}>5. Wiadomości e-mail</h2>
      <p>
        Wysyłamy tylko wiadomości: potwierdzające rejestrację/logowanie lub status zamówienia.
        Nie wysyłamy newsletterów ani treści marketingowych bez zgody.
      </p>

      <h2 style={{ marginTop: "30px" }}>6. Pliki cookies i analityka</h2>
      <p>
        Używamy cookies w celu zapewnienia działania serwisu, zapamiętania preferencji i analityki ruchu.
        Możesz zarządzać cookies w ustawieniach przeglądarki.
      </p>

      <h2 style={{ marginTop: "30px" }}>7. Udostępnianie danych</h2>
      <p>Dane mogą być udostępniane wyłącznie:</p>
      <ul>
        <li>dostawcom usług IT, hostingu, komunikacji e-mail lub wsparcia,</li>
        <li>współpracującym restauracjom – w zakresie realizacji zamówienia,</li>
        <li>organom publicznym – gdy wymagają tego przepisy prawa.</li>
      </ul>
      <p>
        Wszystkie podmioty przetwarzające dane działają na podstawie umów powierzenia i stosują odpowiednie zabezpieczenia.
      </p>
      <p>
        <strong>Przekazywanie danych restauracjom:</strong> restauracje są niezależnymi administratorami danych
        w zakresie realizacji zamówienia i obsługi reklamacji.
      </p>

      <h2 style={{ marginTop: "30px" }}>8. Przekazywanie danych poza EOG</h2>
      <p>
        Jeśli dane są przekazywane poza EOG (np. do Google LLC), stosujemy standardowe klauzule umowne (SCC).
      </p>

      <h2 style={{ marginTop: "30px" }}>9. Okres przechowywania danych</h2>
      <ul>
        <li>dane konta: do usunięcia konta lub po 12 miesiącach braku aktywności,</li>
        <li>dane zamówień: 3 lata w celach dowodowych i rozliczeniowych,</li>
        <li>dane techniczne: do 24 miesięcy.</li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>10. Prawa użytkownika</h2>
      <p>
        Masz prawo dostępu, sprostowania, usunięcia, ograniczenia, przenoszenia danych
        oraz sprzeciwu wobec przetwarzania. Możesz napisać na{" "}
        <a href="mailto:privacy@lungoapp.pl">privacy@lungoapp.pl</a>.
      </p>
      <p>
        Przysługuje Ci też prawo skargi do Prezesa UODO.
      </p>

      <h2 style={{ marginTop: "30px" }}>11. Bezpieczeństwo danych</h2>
      <p>
        Stosujemy środki techniczne i organizacyjne chroniące dane (szyfrowanie, kontrola dostępu, kopie zapasowe).
        Dostęp mają tylko upoważnione osoby.
      </p>

      <h2 style={{ marginTop: "30px" }}>12. Dane osób niepełnoletnich</h2>
      <p>
        Usługi są przeznaczone dla osób pełnoletnich. Nie zbieramy danych dzieci poniżej 16 lat.
      </p>

      <h2 style={{ marginTop: "30px" }}>13. Zmiany Polityki</h2>
      <p>
        Polityka może być aktualizowana. O zmianach poinformujemy na stronie{" "}
        <a href="https://lungoapp.pl/privacy" target="_blank" rel="noreferrer">
          https://lungoapp.pl/privacy
        </a>. Nowa wersja obowiązuje od daty publikacji.
      </p>

      <p style={{ marginTop: "30px" }}>
        Kontakt w sprawach prywatności:{" "}
        <a href="mailto:privacy@lungoapp.pl">privacy@lungoapp.pl</a>
      </p>
    </div>
  );
}
